import { __awaiter, __generator } from "tslib";
import { Topology } from '@wix/wixstores-client-core/dist/es/src/constants';
import { BIService } from './BIService';
export var RemoteSourceTypes;
(function (RemoteSourceTypes) {
    RemoteSourceTypes["ReadOnly"] = "ReadOnly";
    RemoteSourceTypes["ReadWrite"] = "ReadWrite";
    RemoteSourceTypes["Node"] = "Node";
})(RemoteSourceTypes || (RemoteSourceTypes = {}));
var BaseApi = /** @class */ (function () {
    function BaseApi(_a) {
        var siteStore = _a.siteStore, origin = _a.origin;
        this.origin = origin;
        this.siteStore = siteStore;
        this.biService = new BIService({ siteStore: siteStore, origin: origin });
    }
    BaseApi.prototype.absoluteUrl = function (url) {
        return this.siteStore.resolveAbsoluteUrl(url);
    };
    Object.defineProperty(BaseApi.prototype, "endpoints", {
        get: function () {
            var _a;
            var _this = this;
            return _a = {},
                _a[RemoteSourceTypes.ReadOnly] = this.absoluteUrl("/" + Topology.STOREFRONT_GRAPHQL_URL),
                _a[RemoteSourceTypes.ReadWrite] = this.absoluteUrl("/" + Topology.READ_WRITE_GRAPHQL_URL),
                _a[RemoteSourceTypes.Node] = this.absoluteUrl("/" + Topology.NODE_GRAPHQL_URL),
                _a.cartCommmands = function (command) {
                    return _this.absoluteUrl("" + Topology.CART_COMMANDS_URL.replace('{commandName}', command));
                },
                _a;
        },
        enumerable: false,
        configurable: true
    });
    BaseApi.prototype.post = function (url, data, queryParams) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.siteStore.httpClient.post(url, data, { queryParams: queryParams }).catch(function (e) {
                            var _a, _b;
                            if ((_b = (_a = e.data) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.errors) {
                                // eslint-disable-next-line @typescript-eslint/no-throw-literal
                                throw { success: false, errors: e.data.response.errors };
                            }
                            // eslint-disable-next-line @typescript-eslint/no-throw-literal
                            throw e;
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    BaseApi.prototype.fetch = function (_a, source) {
        var query = _a.query, variables = _a.variables, operationName = _a.operationName;
        if (source === void 0) { source = RemoteSourceTypes.ReadWrite; }
        return this.siteStore.tryGetGqlAndFallbackToPost(this.endpoints[source], {
            query: query,
            variables: variables,
            operationName: operationName,
            source: 'WixStoresWebClient',
        });
    };
    return BaseApi;
}());
export { BaseApi };
//# sourceMappingURL=BaseApi.js.map